import { StarIcon } from '@heroicons/react/24/outline';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  DropdownMenu,
  DropdownMenuDeleteItem,
  DropdownMenuIconButton,
  Text,
} from '@/shared/ui';

type Props = {
  title: string;
  isFavorite: boolean;
  onClick?: () => void;
  onRename?: () => void;
  onToggleFavorite?: () => void;
  onDelete?: () => void;
};

export const ChatHistoryItem: FC<Props> = ({
  title,
  isFavorite,
  onClick,
  onRename,
  onToggleFavorite,
  onDelete,
}) => {
  const { t } = useTranslation();

  const menuItems = [
    {
      key: 'rename',
      item: <Text>{t('ai.chat-history.menu-rename')}</Text>,
      onClick: onRename,
    },
    {
      key: 'favorite',
      item: (
        <Text>
          {isFavorite ? t('ai.chat-history.menu-unfavorite') : t('ai.chat-history.menu-favorite')}
        </Text>
      ),
      hasBottomSeparator: true,
      onClick: onToggleFavorite,
    },
    {
      key: 'delete',
      item: <DropdownMenuDeleteItem />,
      onClick: onDelete,
    },
  ];

  return (
    <Button
      type="button"
      variant="ghost"
      className="group h-8 w-full justify-start gap-2 px-3"
      onClick={onClick}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {isFavorite && <StarIcon className="size-4 shrink-0 text-text-muted" />}
        <Text as="span" truncate className="text-text-secondary">
          {title}
        </Text>
      </div>
      {/* biome-ignore lint/a11y/noStaticElementInteractions: イベント伝播停止のためのラッパー */}
      <span
        className="shrink-0 opacity-0 transition-opacity group-hover:opacity-100"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <DropdownMenu menuItems={menuItems}>
          <DropdownMenuIconButton
            aria-label={t('common.actions.operations-menu', { name: title })}
          />
        </DropdownMenu>
      </span>
    </Button>
  );
};
